<template>
  <div id="app">
    <navbar class="fixed-top" />
    <b-container
      class="pad-4"
      fluid
    >
      <router-view />
    </b-container>
    <Footer class="footer" />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import StripeConnectService from '@/services/StripeConnectService'
// import PrintService from '@/services/PrintService'
import { mapActions } from 'vuex'

export default {
  name: 'App',
  mounted () {
    window.addEventListener('resize', () => { this.calculateFooterPostion() })
    this.calculateFooterPostion()
    this.fetchStripeUserId()
    // this.fetchPrinterLang()
  },
  methods: {
    calculateFooterPostion () {
      // height of elements
      const windowSize = window.innerHeight || document.documentElement.clientHeight
      const navHeight = document.querySelector('.fixed-top').getBoundingClientRect().height
      const footerHeight = document.querySelector('.footer').getBoundingClientRect().height
      // main container element
      const mainContainer = document.querySelector('.pad-4')
      // set main container height equal to: window - (nav+footer)
      let height = windowSize - (navHeight + footerHeight)
      mainContainer.setAttribute('style', `min-height:${height}px`)
    },
    async fetchStripeUserId () {
      let response = await StripeConnectService.fetchStripeUserId()
      if (response.data.stripeUserId) {
        this.setStripeConnectUserId(response.data.stripeUserId)
      }
    },
    /* async fetchPrinterLang () {
      try {
        let response = await PrintService.getLang()
        this.setPrinterLanguage(response.data.lang.lang)
      } catch (err) {
        this.setPrinterLanguage(Object.keys(this.$i18n.messages)[0])
      }
    }, */
    // ...mapActions(['setStripeConnectUserId', 'setPrinterLanguage'])
    ...mapActions(['setStripeConnectUserId'])
  },
  components: {
    Navbar,
    Footer
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.navbar {
  background-color: #b71c1c;
}
.navbar-dark .navbar-nav .nav-link {
  color: #fff;
}
.pad-4 {
  padding: 0.5rem;
}
.footer {
  background-color: #b71c1c;
  min-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue